// API Types
export type SupportedLanguage = 'en' | 'es' | 'pt' | 'fr' | 'de' | 'it' | 'ru';

// Define supported languages
export interface SupportedLanguageInfo {
  code: SupportedLanguage;  // Short code like 'en', 'pt'
  name: string;
  voice: string;
}

// API types
export interface UserInfo {
  languageLevel: string;
  age: number;
  conversationType: string;
  speechSpeed: string;
  nativeLanguage: SupportedLanguage;  // Using short code
}

// API processing options
export interface AudioProcessingOptions {
  language: SupportedLanguage;  // Using short code
  platform: string;
  user_info?: UserInfo;
}

export interface TextProcessingOptions {
  language: SupportedLanguage;  // Using short code
  user_info?: UserInfo;
}

// API response types
export interface ApiResponse {
  transcription?: string;
  response: string;
  audioUrl?: string;
  ttsUrl?: string;
  error?: string;
  text?: string;
}
